<template>
  <section>
    <form @submit.prevent="submit">
      <Field
        label="Full Name"
        @input="$v.resource.name.$touch()"
        v-model="resource.name"
        :error="nameError"
      />

      <Field
        label="Email Address"
        @input="$v.resource.email.$touch()"
        v-model="resource.email"
        :error="emailError"
      />

      <Field
        v-model="resource.company_id"
        label="company"
        type="select"
        @input="$v.resource.company_id.$touch"
        :options="companies"
        :error="company_idError"
      />

      <Field
        label="admin"
        v-model="resource.admin"
        type="checkbox"
        @input="$v.resource.admin.$touch"
        :error="adminError"
      />

      <h1>Permissions</h1>

      <div class="permissions">
        <fieldset
          v-for="(actions, relm, index) in availablePermissions"
          :key="`${relm}-${index}`"
        >
          <div class="permission-heading">
            <Sprite :name="relm" />
            <h2>{{ relm }}</h2>
          </div>

          <div
            class="relm-wrapper"
            v-for="(action, index) in actions"
            :key="`${action}-${index}`"
          >
            <input
              :id="`${action}-${relm}`"
              type="checkbox"
              class="action-checkbox"
              v-model="resource.permissions[relm]"
              :value="action"
              @input="$v.resource.permissions.$touch"
            />

            <label :for="`${action}-${relm}`">{{ action }} {{ relm }}</label>
          </div>
        </fieldset>
      </div>

      <error :error="permissionsError" />

      <hr>

      <div class="btn-save">
        <Btn primary>Save Changes</Btn>
      </div>
    </form>
  </section>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'
import Error from '@/components/Error'
import Sprite from '@/components/Sprite'

import {errorMessages} from '@/lib/error_messages'
import {required, email} from 'vuelidate/lib/validators'

export default {
  name: 'UserForm',

  mixins: [form],

  props: {
    companies: {
      type: Array,
      default() {
        return []
      }
    },

    availablePermissions: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  components: {
    Btn,
    Error,
    Sprite
  },

  computed: {
    ...errorMessages([
      'name',
      'admin',
      'email',
      'password',
      'permissions',
      'company_id'
    ])
  },

  validations: {
    resource: {
      admin: {},
      name: {required},
      email: {required, email},
      permissions: {},
      company_id: {required}
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.permissions
  @extend %permissions
</style>
